module.exports = __webpack_public_path__ + "static/img/map.b8f7f72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutus/map.jpg
// module id = aYie
// module chunks = 6